var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M5 2c-.554 0-1 .446-1 1v10c0 .554.446 1 1 1h6c.554 0 1-.446 1-1V3c0-.554-.446-1-1-1zm.5 1h5c.277 0 .5.223.5.5v7c0 .277-.223.5-.5.5h-5a.5.5 0 0 1-.5-.5v-7c0-.277.223-.5.5-.5m2 9h1a.499.499 0 1 1 0 1h-1a.499.499 0 1 1 0-1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModelIcon);
export default __webpack_public_path__ + "static/media/ModelIcon.cf55f44b7512f384cac5af43f189068d.svg";
export { ForwardRef as ReactComponent };